<template>
  <section id="print">
    <div class="rowVar">
      <ul class="list-print">
        <template v-for="(variety, index) in varieties">
          <template v-if="$route.query.quantity">
            <li v-for="q in +$route.query.quantity" class="variety varietyRow">
              <div class="varietyContainer">
                <div :key="q * index + index" class="barcodeContainer">
                  <textarea  
                      rows="1"  
                      type="text"  
                      v-model="productName"  
                      class="varietyPrice"  
                      @input="adjustHeight"  
                  ></textarea> 
                  <div class="row">
                      <div v-for="item in variety[5]" class="itemRow">
                        <span class="varName">
                          {{ item.value }}
                        </span>
                      </div>
                  </div>

                  <barcode
                    class="varietyBarcode"
                    fontSize="40"
                    width="7"
                    marginBottom="0"
                    marginTop="0"
                    elementTag="img"

                    :displayValue="true"
                    height="50"
                    :value="variety[0]"
                  >
                  </barcode>

                  <span class="priceName">
                    {{ variety[2].slice(0, variety[2].indexOf("تومان")) }}
                    <b>تومان</b>
                  </span>
                </div>
              </div>
            </li>
          </template>
          <template v-else>
            <li v-for="q in variety[3]" class="variety varietyRow">
              <div class="varietyContainer">
                <div :key="q * index + index" class="barcodeContainer">
                  <textarea  
                      rows="1"  
                      type="text"  
                      v-model="productName"  
                      class="varietyPrice"  
                      @input="adjustHeight"  
                  ></textarea> 
                  <div class="row">
                    <div v-for="item in variety[5]" class="itemRow">
                      <span class="varName">
                        {{ item.value }}
                      </span>
                    </div>
                  </div>
                  <barcode
                    class="varietyBarcode"
                    fontSize="40"
                    elementTag="img"
                    width="7"
                    marginBottom="0"
                    marginTop="0"
                    :displayValue="true"
                    height="60"
                    :value="variety[0]"
                  >
                  </barcode>

                  <span class="priceName" v-if="parsePrice(variety[8]) > parsePrice(variety[2])">
                    <del>
                      {{ variety[8] }}
                    </del>  
                  </span>
                  <span class="priceName">
                    {{ variety[2].slice(0, variety[2].indexOf("تومان")) }}
                    <b>تومان</b>
                  </span>
                </div>
              </div>
            </li>
          </template>
        </template>
      </ul>
    </div>
    <button id="printBtn" @click="print">پرینت</button>
  </section>
</template>

<script>
import printVarietiesImpl from "@@/core/pages/printVarieties/printVarietiesImpl";
export default {
  extends: printVarietiesImpl,
};
</script>

<style src="@@/core/pages/printVarieties/printVarietiesStyle.css"></style>
